import { getContactKey, getContactName } from './contactUtils';

export const _setNewContactForm = (state, action) => {
  state.newContactForm = action.payload;
};

export const _setCntId = (state, action) => {
  state.cntId = action.payload;
};

export const _setCntKey = (state, action) => {
  state.cntKey = action.payload;
};

export const _setCntDept = (state, action) => {
  state.cntDept = action.payload;
};

export const _setAuthLock = (state, action) => {
  state.authLock = action.payload;
};

export const _setHonorific = (state, action) => {
  state.honorific = action.payload;
};

export const _setPhone = (state, action) => {
  state.phone = action.payload;
};

export const _setFax = (state, action) => {
  state.fax = action.payload;
};

export const _setCntOrgId = (state, action) => {
  state.cntOrgId = action.payload;
};

export const _setPlacementCoordinator = (state, action) => {
  state.placementCoordinator = action.payload;
};

export const _setCaseManager = (state, action) => {
  state.caseManager = action.payload;
};

export const _setParoleAgent = (state, action) => {
  state.paroleAgent = action.payload;
};

export const _setSupervisorChkBox = (state, action) => {
  state.supervisorChkBox = action.payload;
};

export const _setDataEntry = (state, action) => {
  state.dataEntry = action.payload;
};

export const _setCntInactiveYn = (state, action) => {
  state.cntInactiveYn = action.payload;
  // state.cntKey = getContactKey(
  //   state.lastName,
  //   state.firstName,
  //   state.middleName,
  //   state.cntInactiveYn
  // );
};

export const _setNetworkUserName = (state, action) => {
  state.networkUserName = action.payload;
};

export const _setCounty = (state, action) => {
  state.county = action.payload;
};

export const _setCntSprCntId = (state, action) => {
  state.cntSprCntId = action.payload;
};

export const _setCntEditCntId = (state, action) => {
  state.cntEditCntId = action.payload;
};

export const _setCntName = (state, action) => {
  state.cntName = action.payload;
};

export const _setFirstName = (state, action) => {
  state.firstName = action.payload;
  state.cntKey = getContactKey(
    state.lastName,
    state.firstName,
    state.middleName,
    state.cntId
  );
  state.cntName = getContactName(
    state.lastName,
    state.firstName,
    state.middleName
  );
};

export const _setMiddleName = (state, action) => {
  state.middleName = action.payload;
  state.cntKey = getContactKey(
    state.lastName,
    state.firstName,
    state.middleName,
    state.cntId
  );
  state.cntName = getContactName(
    state.lastName,
    state.firstName,
    state.middleName
  );
};

export const _setLastName = (state, action) => {
  state.lastName = action.payload;
  state.cntKey = getContactKey(
    state.lastName,
    state.firstName,
    state.middleName,
    state.cntId
  );
  state.cntName = getContactName(
    state.lastName,
    state.firstName,
    state.middleName
  );
};

export const _setSuffix = (state, action) => {
  state.suffix = action.payload;
};

export const _setTitle = (state, action) => {
  state.title = action.payload;
};

export const _setDirectPhone = (state, action) => {
  state.directPhone = action.payload;
};

export const _setCntMailAdrPrefix = (state, action) => {
  state.cntMailAdrPrefix = action.payload;
};

export const _setCntMailAdr = (state, action) => {
  state.cntMailAdr = action.payload;
};

export const _setAddress1 = (state, action) => {
  state.address1 = action.payload;
};

export const _setAddress2 = (state, action) => {
  state.address2 = action.payload;
};

export const _setWcCalOMSContact2 = (state, action) => {
  state.wcCalOMSContact2 = action.payload;
};

export const _setCity = (state, action) => {
  state.city = action.payload;
};

export const _setState = (state, action) => {
  state.state = action.payload;
};

export const _setZip = (state, action) => {
  state.zip = action.payload;
};

export const _setEmail = (state, action) => {
  state.email = action.payload;
};

export const _setCreatedDate = (state, action) => {
  state.createdDate = action.payload;
};

export const _setEditDate = (state, action) => {
  state.editDate = action.payload;
};

export const _setComment = (state, action) => {
  state.comment = action.payload;
};

export const _setCntCreateCntId = (state, action) => {
  state.cntCreateCntId = action.payload;
};

export const _setProbationOfficer = (state, action) => {
  state.probationOfficer = action.payload;
};

export const _setOrganization = (state, action) => {
  state.organization = action.payload;
};

// export const _setSupervisor = (state, action) => {
//   state.supervisor = action.payload;
// };

// export const _setDepartMent = (state, action) => {
//   state.departMent = action.payload;
// };

export const _setContactCreatedby = (state, action) => {
  state.contactCreatedby = action.payload;
};

export const _setContactEditedby = (state, action) => {
  state.contactEditedby = action.payload;
};
